<template>
  <div class="modal fade" id="creat-employee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <slot :newEmployee="formData">
    <div
      class=" write-msg-model creat-employee-modal"
    >
      <div class="modal-dialog  modal-lg modal-dialog-centered save-flash d-none" :class="{showFlash:flashShowCls}">
        <div class="col-lg-12 save-flash-d">
            <p class="text-align-center save-flash-p">
                Employee saved successfully.
            </p>
        </div>
      </div>
      <div class="modal-dialog modal-lg modal-dialog-centered" :class="{mContentT:flashShowCls}" role="document">
        <div class="modal-content">
          <form ref="formModalData">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Create New Employee</h5>
              <p class="gray-text">
                Please make sure that the entered information is correct.
              </p>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearRequiredCond"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
              <!-- <div class="save-flash">
                Employee saved successfully.
              </div> -->
          <div class="modal-body">
            <div class="">
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col">
                    <label for="exampleFormControlSelect1">Company</label>
                      <input
                        type="text"
                        class="form-control text-capitalize"
                        v-model="selectedCompanyName"
                        :placeholder="selectedCompanyName"
                        readonly
                      />

                  </div>
                  <div class="field-col">
                    <label>Employee Number:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.reg_no"

                    />
                    <p v-if="errorRegAlready === 'invalid'" :class="{textRed : errorRegAlready === 'invalid'}">Employee number already exists</p>
                  </div>
                  <div class="field-col">
                    <label>Employee Id</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.employee_nic"
                      placeholder=""
                      @keyup="validateInput($event,'empl_nic')"
                    />
                    <p id="errmsgOnlyNum" class="d-none"></p>
                  </div>
                  <div class="field-col">
                    <!-- :class="{textRed : validity.fname === 'invalid' || validity.fname === 'invalid-char'}" -->
                    <label><span>First Name: *</span></label>
                    <input
                      type="text"
                      class="form-control text-capitalize"
                      v-model.trim="formData.fname"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength = "40"
                      placeholder=""
                      @keyup="validateInput($event,'firstname')"
                    />
                    <p v-if="validity.fname === 'invalid'" :class="{textRed : validity.fname === 'invalid'}">First name is required</p>
                  </div>
                  <div class="field-col">
                    <label><span>Last Name: *</span></label>
                    <input
                      type="text"
                      class="form-control text-capitalize"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength = "40"
                      v-model.trim="formData.lname"
                      placeholder=""
                     @keyup="validateInput($event,'lastname')"
                    />
                    <p v-if="validity.lname === 'invalid'" :class="{textRed : validity.lname === 'invalid'}">Last name is required</p>
                  </div>
                  <div class="field-col">
                    <label><span>Email *</span>
                      <div class="check-wrap">
                        <span class="msg-text">Skip email</span>
                        <input type="checkbox" v-model="autogenerated" @change="skipEmail($event)" >
                      </div>
                    </label>

                    <input
                      type="email"
                      class="form-control"
                      v-model.trim="formData.email"
                      placeholder=""
                      :disabled="autogenerated"
                      @keyup="validateInput($event,'email')"
                    />
                    <p v-if="validity.email === 'invalid'" :class="{textRed : validity.email === 'invalid'}">Enter valid email</p>
                  </div>
                  <div class="field-col">
                    <label >
                       <span>
                        Phone *
                      </span>
                      </label>
                    <VuePhoneNumberInput
                      v-model.trim="phoneNum"
                     :default-country-code="countryCode" size="sm"
                      :translations="{countrySelectorLabel: ''}"
                      :clearable="true"
                      :show-code-on-list="true"
                      @update="getFormatedNum"
                      @input="changeCss"
                     />

                    <p v-if="errorPhoneAlready === 'invalid'" :class="{textRed : errorPhoneAlready === 'invalid'}">Phone already exists</p>
                    <p v-if="validity.phone === 'invalid'" :class="{textRed : validity.phone === 'invalid'}">Phone number is required</p>
                    <p v-text="errorMsgePhone" class="textRed"></p>
                  </div>
                  <div class="field-col">
                    <label>Address</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.address"
                      placeholder=""
                    />
                  </div>
                  <div class="field-col">
                    <label>Gender</label>
                    <div class="nav-selectdrop">
                      <select id="" class="form-control" v-model="formData.gender">
                        <option value="male"> Male </option>
                        <option value="female"> Female </option>
                        <option value="other"> Other </option>
                      </select>
                    </div>

                  </div>
                  <div class="field-col">
                    <label>Bank Name</label>
                    <input type="text" class="form-control text-capitalize" required v-model="formData.bank_name"
                           oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                           maxlength = "30"
                           placeholder="">
                  </div>
                  <div class="field-col">
                    <label>Account Number</label>
                    <input
                      type="text"
                      min='1' max='2'
                      class="form-control"
                      v-model="formData.account_no"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength = "20"
                      @keyup="validateInput($event,'acc_num_only')"
                    />
                    <p id="accNumOnlyTag" class="d-none"></p>
                    <p v-if="validity.account === 'invalid'" :class="{textRed : validity.account === 'invalid'}">Account number should be numbers</p>
                  </div>
                  <div class="field-col">
                    <label>IBAN </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.account_iban"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength = "30"
                      placeholder=""
                    />
                  </div>
                  <div class="field-col">
                    <label>Emergency Contact Name</label>
                    <input type="text" class="form-control text-capitalize" required v-model="formData.emergency_contact_name"
                           oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                           maxlength = "40"
                           placeholder="">
                  </div>
                  <div class="field-col">
                    <label>Relationship</label>
                    <input type="text" class="form-control text-capitalize" v-model="formData.emergency_relation"
                           oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                           maxlength = "20"
                           placeholder="">
                  </div>
                  <div class="field-col">
                    <label>Emergency Number </label>
                    <input type="tel" class="form-control" v-model="formData.emergency_contact_phone"
                           oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                           maxlength = "20"
                           placeholder="">
                  </div>
                  <div class="field-col">
                    <label>Joining Date</label>
                    <date-picker v-model="formData.emp_availability" lang="en" type="date" format="MM-DD-YYYY" width="220" ></date-picker>
                  </div>
                  <div class="field-col">
                    <label>Salary Disbursement Date</label>
                    <div class="nav-selectdrop">
                      <select
                        class="form-control scroller"
                        v-model="formData.salary_period"
                      >
                        <option v-for="one of salary_period2" :key="one" :value="one"> {{ one }} </option>
                      </select>
                    </div>
                  </div>
							</div>
              </div>
            </div>
            <div class="modal-title sub-title">
              <h5>What are the employee job roles in the schedule</h5>
              <p class="gray-text">
                Choose what job roles or responsibility the employee has. {{ validity.roles }}
              </p>
              <p v-if="validity.roles === 'invalid'" :class="{textRed : validity.roles === 'invalid'}">
                job role is required
              </p>
            </div>

            <div class="employee-position">
              <ul class="emp-job-list">
                <li v-for="role of jobRoles" :key="role.id">
                  <div class="sticky-check">
                    <label class="custom-check-box">
                      <input type="checkbox" v-model="formData.empl_role" :value="role.id" @change="getRoleIds($event,'positions')"/>
                      <span class="radio-check text-capitalize"> {{ role.name }} </span>
                    </label>
                  </div>
                </li>
              </ul>
              <button type="button" class="btn btn-primary btn-sm mt-5 mb-5" @click="showHideSelect">Add job roles</button>
              <multiselect
                v-show="selectShowHide"
                v-model="getlist"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                label="name"
                track-by="name"
                :options="options"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                :max-height="200"
                @select="onSelect"
                @remove="deleteTag"
              ></multiselect>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
              @click="clearRequiredCond"
              >Cancel</button>
            <button type="button" @click="submitData" :disabled="createEmployeeBtnDisble" class="btn btn-outline-primary btn-sm f-bold" >
              <span><clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader></span>   <span v-show="createBtn">Create Employee</span>
            </button>
          </div>
          </form>
        </div>
      </div>
    </div>
    </slot>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
// import "../../assets/css/tel/vue-phone-number-input.css"
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Multiselect from "vue-multiselect";

export default {
  name: "createEmployeeModal",
  components: {
			DatePicker,VuePhoneNumberInput,ClipLoader,Multiselect
		},
  props:[

  ],
  data() {
    return {
      size        : '25px',
      spinnerColor: '#00779C',
      loadingSpin : false,
      createEmployeeBtnDisble : false,
      createBtn   : true,
      countryCode :'DK',
      selectShowHide : false,
      errorPhoneAlready : '',
      formData: {
        reg_no: "",
        employee_nic: "",
        company: "",
        fname: "",
        lname: "",
        salary_period: "",
        address: "",
        emp_availability: "",
        phone: "",
        account_no: "",
        account_iban: "",
        email: "",
        emergency_contact_phone:"",
        emergency_contact_name:"",
        password:"",
        type:"EMPLOYEE",
        decrypt_password:"",
        remoteWork:'no',
        managerAccess:'no',
        empl_role:[],
        gender:'male',
        user_name :'',
        emergency_relation :'',
        bank_name :'',
        countryCode : '',
        is_skip: 0
      },
      validity:{
        phone:'',
        email:'',
        fname:'',
        lname:'',
        account_no:'',
        account:'',
        roles:'',
      },
      roleIds:[],
      options: [],
      getlist: [],
      selectedCompanyName:this.$store.getters.getSelectedCompany.name,
      jobRoles:this.$store.getters.getSelectedCompany.jobRoles,
      salary_period2:30,
      reg_no:'',
      phoneNum:'',
      flashShowCls:false,
      company_id : this.$store.getters.getSelectedCompany.id,
      autogenerated : false,
      errorRegAlready: '',
      errorMsgePhone:'',
      limit:0,
      accNumOnly:'',
      regValid:''
    };
  },
  mounted() {
  let selcComp = this.$store.getters.getSelectedCompany;

  if (selcComp.length !== 0 && selcComp.currency) {
    this.countryCode = selcComp.currency.ios2 || 'DK';
  } else {
    // Provide a default value if currency or ios2 is not available
    this.countryCode = 'DK';
  }

  this.getJobRolesList();
  this.checkEmployeeRegNo();

  this.$root.$on("refreshJobRoles", () => {
    if (selcComp.length !== 0) {
      this.jobRoles = selcComp.jobRoles || [];
      this.countryCode = selcComp.currency ? selcComp.currency.ios2 || 'DK' : 'DK';
    }
  });

  $(document).on('keypress', '.input-tel__input', function (e) {
    if (this.value.length == 0 && e.which == 48) {
      e.preventDefault();
    }
  });
},


  methods: {
    changeCss() {
       if (window.innerWidth <= 480) {
        $(".vue-phone-number-input.sm .select-country-container").css({
          "flex": "0 0 55px",
          "min-width": "55px",
          "max-width": "55px",
        });
        $(".input-tel.sm .input-tel__label").css({
         "margin":"-6px",
         "font-size":"7px"
        });
      }
      if (window.innerWidth > 480) {
        $(".vue-phone-number-input.sm .select-country-container").css({
          "flex": "0 0 0px",
          "min-width": "95px",
          "max-width": "75px",
        });
        $(".input-tel.sm .input-tel__label").css({
         "margin":"-6px",
         "font-size":"8px"
        });
      }
  // $(".vue-phone-number-input.sm .select-country-container").css({
  //   "flex": "0 0 55px",
  //   "min-width":"55px",
  //   "max-width":"55px",
  //   // "margin": "-4px -9px 0 -13px"
  // });
},
    deleteTag(removedOption) {
      if (confirm("Are you sure you want to delete this job type?")) {
        this.$axios({
          method: "POST",
          data: { name: removedOption.name, company_id: this.$store.getters.getSelectedCompany.id },
          url: this.$DeleteTag,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            this.$store.commit("setUser", res.data.result);
            $root.$toast.success(res.data.message);
            this.jobRoles = this.$store.getters.getSelectedCompany.jobRoles;
            if (this.getlist.length === 0) {
              this.jobRequired = "";
            }
          } else if (res.data.status == 403) {
            this.getlist = this.getlist2;
            $root.$toast.error(res.data.message);
          }
        });
      } else {
        this.getJobRolesList();
      }
    },
    skipEmail(e){
      if(this.autogenerated){
        this.formData.is_skip = 1;
      }else{
        this.formData.is_skip = 0;
      }
    },
    autoGeneratedEmail(value){
      if(this.autogenerated===true){
        this.$axios
          .post(
            this.$AutoGeneratedEmail,
            {
              first_name: this.formData.fname,
              last_name: this.formData.lname,
              company_id: this.company_id,
            },
            {
              headers: this.getAuthHeader(),
            }
          )
          .then((response) => {
            this.formData.email=response.data.result;
          });
      }else{
        this.formData.email='';
      }
    },
    emailAvailability(email){
      this.$axios({
        method: "GET",
        params: {
          company_id: this.company_id,
          email: email
        },
        url: this.$validateEmail,
        headers: this.getAuthHeader()
      }).then(res => {
       return res;
      });
    },
    phoneAvailability(phone){
      this.$axios
        .post(
          this.$validatePhone,
          { phone: phone},
          {
            headers: this.getAuthHeader(),
          }
        )
        .then((response) => {
          this.formData.phone=response.data.result;
        });
    },
    showHideSelect(){
      if(this.selectShowHide){
        this.selectShowHide = false;
      }else{
        this.selectShowHide = true;
      }
    },
    clearRequiredCond(){
      this.validity.phone = '';
      this.validity.email = '';
      this.validity.fname = '';
      this.validity.lname = '';
      this.validity.roles = '';
      $("#errmsgOnlyNum").hide();
      this.resetForm();
    },
    onlyNumber(event){
      var thisTag = $("#errmsgOnlyNum");
      if (event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57)){
        thisTag.removeClass('d-none');
        thisTag.html("Digits only").css('color','red').show();
        return false;
      }else{
        thisTag.hide();
      }
    },
    submitCompanyJobRole(name) {
      this.$axios
        .post(
          this.$UpdateCompanyJobRoles,
          { company_id: this.company_id, job_role: name },
          {
            headers: this.getAuthHeader(),
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            $root.$toast.success(response.data.message);
             this.$store.commit("setUser", response.data.result);
            this.jobRoles = this.$store.getters.getSelectedCompany.jobRoles;
          }
          if(response.data.status == 402){
            this.jobRoles = this.$store.getters.getSelectedCompany.jobRoles;
            $root.$toast.error(response.data.message);

          }
        })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },
    getFormatedNum(e){
      let phoneLimit = e.phoneNumber ? e.phoneNumber.replace(/\s/g, '').length : '';
      if(e.isValid == true){
        let numLength = String(e.formatNational).replace(/\s/g, '').length;
        this.limit    = String(e.formatNational).substring(0,1) == 0 ? numLength-1:numLength;
      }
      if(phoneLimit > this.limit && this.limit !== 0){
        this.errorMsgePhone           = "Invalid phone number";
        this.createEmployeeBtnDisble  = true;
      }else{
        this.errorMsgePhone           = "";
        this.createEmployeeBtnDisble  = false;
        this.validity.phone           = '';
        this.formData.phone           = e.formattedNumber;
        this.formData.countryCode = JSON.stringify({
          emergency_cc      : e.countryCallingCode ? '+'+e.countryCallingCode : '',
          emergency_cc_name : e.countryCode ? e.countryCode : '',
          user_cc           : e.countryCallingCode ? '+'+e.countryCallingCode : '',
          user_cc_name      : e.countryCode ? e.countryCode : ''
        });
      }
    },
    addTag(newTag) {
      this.getlist.push({ name: newTag });
      this.submitCompanyJobRole(newTag);
    },
    onSelect(selectedItems) {
      this.submitCompanyJobRole(selectedItems.name);
    },
    getJobRolesList() {
      let params = { list_type: ["job_roles"] };
      this.$axios({
        method: "get",
        params: params,
        url: this.$Getlistdata,
      })
        .then((response) => {
          this.options = response.data.result.job_roles;
          this.getlist = this.$store.getters.getSelectedCompany.jobRoles;
        })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },
    validateInput(event,fieldname = ''){
      if(fieldname === 'firstname' || fieldname === ''){
          var letters = /^[A-Za-z]+$/;
          if(this.formData.fname === ''){
            this.validity.fname = 'invalid'
          }else{
            this.validity.fname = '';
          }
      }
      if(fieldname === 'lastname' || fieldname === ''){
           var letters = /^[A-Za-z]+$/;
          if(this.formData.lname === ''){
            this.validity.lname = 'invalid'
          }else{
            this.validity.lname = ''
          }
      }
      if(!this.autogenerated){
        if(fieldname === 'email' || fieldname === ''){
          var re = /\S+@\S+\.\S+/;
          if(!re.test(this.formData.email)){
            this.validity.email = 'invalid'
          }else{
            this.validity.email = ''
          }
        }
      }else{
        this.validity.email = ''
      }
      if(fieldname === 'empl_nic'){
        var lettersreg_no = /^[0-9]+$/;
        var thisTag       = $("#errmsgOnlyNum");
        if (!lettersreg_no.test(this.formData.employee_nic)){
          thisTag.removeClass('d-none');
          thisTag.html("Digits Only").css('color','red').show();
          this.regValid = 'yes';
        }else{
          thisTag.hide();
          this.regValid = '';
        }
      }
      if(fieldname === 'acc_num_only'){
        var lettersreg_no = /^[0-9]+$/;
        var thisTag       = $("#accNumOnlyTag");
        if (!lettersreg_no.test(this.formData.account_no)){
          thisTag.removeClass('d-none');
          thisTag.html("Digits Only").css('color','red').show();
          this.accNumOnly = 'yes';
        }else{
          thisTag.hide();
          this.accNumOnly = '';
        }
      }
      if(this.formData.empl_role.length === 0 && fieldname === ''){
        this.validity.roles = 'invalid';
      }else{
        this.validity.roles = '';
      }

      if(this.validity.phone == ''&&this.validity.email == ''&&this.validity.fname == ''&&this.validity.lname == ''&&this.regValid==''&&this.accNumOnly==''&&this.validity.account==''&&this.validity.roles==''){
        return true
      }else{
        return false
      }
    },
    checkEmployeeRegNo(){
      this.$axios({
        method: "GET",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id
        },
        url: this.$CheckEmployeeRegNo,
        headers: this.getAuthHeader()
      }).then(res => {
        if(res.data.status == 200){
          if(res.data.result == null){
            this.reg_no = '001';
          }else{
            this.reg_no = res.data.result.id;
            this.reg_no++;
            this.reg_no = '00'+this.reg_no;
            this.formData.reg_no = this.reg_no;
          }
        }
      });
    },
    getRoleIds(event,fieldname){
      this.validateInput(event,fieldname);
    },
    submitData(e) {
      this.phoneNumValidation();
      if(this.validateInput()){
        this.createEmployeeBtnDisble          = true;
        this.createBtn                  = false;
        this.loadingSpin                = true;
        this.formData.company           = this.$store.getters.getSelectedCompany.id;
        this.formData.decrypt_password  = "";
        this.formData.user_name         = this.$store.getters.getUser.name;   //user name from local storage
          this.$axios({
            method: 'POST',
            data: this.formData,
            url: this.$SaveEmployee,
            headers: this.getAuthHeader()
          }).then((res) => {
            this.createEmployeeBtnDisble  = false;
            this.loadingSpin  = false;
            this.createBtn    = true;
            if(res.data.status == 200){
              this.$root.$emit('activeCompoClick');
              this.$root.$emit('refreshEmployees');
              $('#createbtn').text('d-block');
              this.flashShowCls = true;
              this.$router.push({name: 'employees'});
              this.$router.go(0);
              this.hideFlash();
              this.checkEmployeeRegNo();
              this.resetForm();
              $('#creat-employee').modal('hide');
              // Save the updated list to local storage
              localStorage.setItem('companyEmployees', JSON.stringify(null));
              $root.$toast.success('Employee created successfully');
            }else if(res.data.message=='phone_already'){
              this.errorPhoneAlready='invalid';
            }else if(res.data.message=='reg_no_already'){
              this.errorRegAlready='invalid';
            }
          });
      }
    },
    phoneNumValidation(){
      if(!this.phoneNum){
        this.validity.phone = 'invalid';
        return false;
      }else{
        this.validity.phone = '';
        // return true;
      }
    },
    hideFlash(){
      setTimeout(()=>{
        this.flashShowCls = false;
      },2000);
    },
    resetForm(){
      this.formData                         = {}
      this.formData.employee_nic            =  "",
      this.formData.company                 =  "",
      this.formData.fname                   =  "",
      this.formData.lname                   =  "",
      this.formData.salary_period           =  "",
      this.formData.address                 =  "",
      this.formData.emp_availability        =  "",
      this.formData.phone                   =  "",
      this.formData.account_no              =  "",
        this.emergency_relation  =  "",
        this.bank_name  =  "",
      this.formData.account_iban            =  "",
      this.formData.email                   =  "",
      this.formData.emergency_contact_phone = "",
      this.formData.emergency_contact_name  = "",
      this.formData.password                = "",
      this.formData.type                    = "EMPLOYEE",
      this.formData.decrypt_password        = "",
      this.formData.remoteWork              = 'no',
      this.formData.managerAccess           = 'no',
      this.formData.empl_role               = [],
      this.formData.gender                  = 'male'
      this.formData.countryCode             = ''
    },
    getCompanyRoles(event){
      this.jobRoles = this.getCompanies.filter(val => val.id == event.target.value)[0].jobRoles;
    }
  },
  computed: {
    getCompanies() {
      return this.$store.getters.getUser.companies;
    },
  }
};
</script>

<style scoped>

.input-tel.sm .input-tel__label[data-v-e59be3b4] {
    font-size: 5px !important;
}
.textRed{
  color: red;
}
.borderRed{
  border: solid red;
}
.creat-employee-modal .modal-header{
  border-bottom: none !important;
}
.save-flash{
  /* margin-left: 10px;
  margin-right: 10px;
  height: 40px;
  background-color: #47d78a;
  padding: 11px;
  border-radius: 5px;
  color: white;
  font-weight: bold; */
  min-height: calc(10% - 4.5rem);
    margin: 28px auto;
    margin-bottom: 4px;
    border-radius: 19px;
}
.save-flash-d{
    background-color: #47d78a;
    border-radius: 5px;
    height: 47px;
}
.save-flash-p{
  padding: 15px;
  color: white;
  font-weight: bold;
}
.mContentT{
  margin-top: -50px !important;
}
.showFlash{
  display: block !important;
}
.country-selector__input{
  padding-top: 0px !important;
}
.country-selector__country-flag{
  top: 11px !important;
}

.creat-employee-modal .inputs-holder label{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.creat-employee-modal .inputs-holder label input{
  cursor: pointer;
}
.creat-employee-modal .inputs-holder label .msg-text{
  font-size: 12px;
  line-height: 16px;
  background: transparent;
  padding-right: 5px;
  padding-left: 5px;
}
.creat-employee-modal .inputs-holder label .check-wrap{
  flex-grow: 1;
  justify-content: right;
  display: flex;
}

.scroller::-webkit-scrollbar {
  width: 8px;
  background: #e9ecef;
}

.scroller::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 6px #ccc;*/
  /*border-radius: 10px;*/
  background: #cdd0e0;
}
/* Track */
.scroller::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.scroller::-webkit-scrollbar-thumb {
  background: #888;
}


</style>
